import React, { useMemo, useState } from "react";
import { BookOpenCheck, CheckCircle2, XCircle, RotateCcw } from "lucide-react";

export const ReadingCard = ({ topic }) => {
  const questions = useMemo(() => topic.reading_questions || [], [topic.id, topic.reading_questions]);
  const [picked, setPicked] = useState({});
  const [checked, setChecked] = useState(false);

  if (!topic.reading_text) return null;

  const score = questions.filter((q, i) => picked[i] === q.answer).length;

  return (
    <div className="mt-8" data-testid="reading-card">
      <div className="glass-soft p-5 sm:p-7">
        <div className="flex items-center gap-2 text-xs font-black text-white/60">
          <BookOpenCheck size={16} />نص القراءة
        </div>
        <h3 className="text-2xl font-black mt-2" dir="ltr" data-testid="reading-title">
          {topic.reading_title}</h3>
        {topic.reading_title_ar && (
          <div className="text-sm text-white/70 mt-1">{topic.reading_title_ar}</div>
        )}
        <p className="mt-5 text-lg leading-[2.2] text-white/90 whitespace-pre-line" dir="ltr"
          data-testid="reading-text">{topic.reading_text}</p>
        {topic.reading_summary_ar && (
          <p className="mt-5 text-sm leading-loose text-white/70 border-t border-white/10 pt-4"
            data-testid="reading-summary">💡 {topic.reading_summary_ar}</p>
        )}
      </div>

      {questions.length > 0 && (
        <div className="glass-soft p-5 sm:p-7 mt-4" data-testid="reading-questions">
          <h4 className="text-base md:text-lg font-black">أسئلة فهم النص</h4>
          <div className="space-y-5 mt-4">
            {questions.map((q, i) => (
              <div key={i} data-testid={`reading-q-${i}`}>
                <div className="font-bold" dir="ltr">{i + 1}. {q.question}</div>
                <div className="grid sm:grid-cols-2 gap-2 mt-2">
                  {q.options.map((op, k) => {
                    const isPicked = picked[i] === k;
                    const right = checked && k === q.answer;
                    const wrong = checked && isPicked && k !== q.answer;
                    return (
                      <button key={k} type="button" disabled={checked}
                        data-testid={`reading-q-${i}-opt-${k}`}
                        onClick={() => setPicked({ ...picked, [i]: k })}
                        className="rounded-xl border-2 px-3 py-2 text-start text-sm font-bold transition-colors"
                        dir="ltr"
                        style={{
                          borderColor: right ? "#3ec46d" : wrong ? "#e8384f"
                            : isPicked ? "var(--play-primary)" : "rgba(255,255,255,.12)",
                          background: isPicked ? "rgba(255,255,255,.10)" : "transparent",
                        }}>
                        {op}
                        {right && <CheckCircle2 size={14} className="inline ms-2 text-emerald-400" />}
                        {wrong && <XCircle size={14} className="inline ms-2 text-red-400" />}
                      </button>
                    );
                  })}
                </div>
                {checked && q.explanation_ar && (
                  <div className="text-xs text-white/70 mt-2">{q.explanation_ar}</div>
                )}
              </div>
            ))}
          </div>

          {checked ? (
            <div className="flex items-center gap-3 mt-6 flex-wrap">
              <span className="font-black" data-testid="reading-score">
                نتيجتك: {score} / {questions.length}</span>
              <button type="button" data-testid="reading-retry"
                onClick={() => { setChecked(false); setPicked({}); }}
                className="pro-btn bg-white/12 text-white border border-white/20 text-xs flex items-center gap-1">
                <RotateCcw size={14} />حاول مرة أخرى</button>
            </div>
          ) : (
            <button type="button" data-testid="reading-check"
              disabled={Object.keys(picked).length < questions.length}
              onClick={() => setChecked(true)}
              className="play-btn text-white mt-6 text-sm disabled:opacity-50"
              style={{ background: "var(--play-secondary)" }}>تحقق من الإجابات</button>
          )}
        </div>
      )}
    </div>
  );
};
